import { useEffect, useRef, useState } from 'react';
// Pixels the on-screen keyboard occludes. 0 when closed. iOS Safari does not
// push `position: fixed` elements above the keyboard, so callers use this to
// translate the AMA drawer manually.
//
// Note: PageTemplateSidebarDrawer sets `interactive-widget=resizes-content`
// on the viewport meta, which makes iOS shrink `window.innerHeight` itself
// when the keyboard opens. We therefore diff against the largest height seen
// so far (the pre-keyboard layout viewport) rather than the live innerHeight.
export function useKeyboardOffset() {
    const [offset, setOffset] = useState(0);
    const maxHeightRef = useRef(0);
    useEffect(() => {
        const vv = window.visualViewport;
        if (!vv)
            return;
        maxHeightRef.current = window.innerHeight;
        let raf = 0;
        const update = () => {
            if (window.innerHeight > maxHeightRef.current) {
                maxHeightRef.current = window.innerHeight;
            }
            const next = Math.max(0, maxHeightRef.current - vv.height - vv.offsetTop);
            cancelAnimationFrame(raf);
            raf = requestAnimationFrame(() => setOffset(next));
        };
        vv.addEventListener('resize', update);
        vv.addEventListener('scroll', update);
        update();
        return () => {
            cancelAnimationFrame(raf);
            vv.removeEventListener('resize', update);
            vv.removeEventListener('scroll', update);
        };
    }, []);
    return offset;
}
